import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TMaskInput } from './models';

export const MaskInput: FC<TMaskInput> = ({
    PureInput,
    className,
    classNames = {},
    disabled,
    id,
    maskSuffix = '',
    name,
    onBlur,
    onChange,
    onFocus,
    onKeyDown,
    paddingleft,
    placeholder,
    separateThousands,
    styles,
    value,
    ...rest
}) => {
    const { input, mask } = classNames;

    return (
        <div className={styles.wrapper}>
            <label className={styles.maskLabel} htmlFor={id} style={{ paddingLeft: paddingleft }}>
                {placeholder}
            </label>
            <PureInput
                autoComplete="off"
                className={cn(styles.external, styles.maskInput, className, input)}
                disabled={disabled}
                id={id}
                inputMode="numeric"
                name={name}
                onBlur={onBlur}
                onChange={onChange}
                onFocus={onFocus}
                onKeyDown={onKeyDown}
                paddingleft={paddingleft}
                pattern="[0-9]*"
                type="text"
                value={value}
                {...rest}
            />

            <label
                className={cn(styles.mask, mask)}
                htmlFor={id}
                style={paddingleft ? { paddingLeft: paddingleft } : {}}
            >
                <span>
                    <span className={styles.separateValue}>{separateThousands(value)}</span>
                    <span className={styles.pureValue}>{value}</span>
                </span>
                <span>&nbsp;{maskSuffix}</span>
            </label>
        </div>
    );
};
